<template>
  <div class="big-screen-page">
    <top @change="showChange" :name="getName" :list="list" />
    <div class="info-body" ref="infoBody">
      <big-title :imgSrc="require('@/assets/images/bigScreen/icon-yq.png')" title="园区属性"
        style="height: 100%;width: 622px;padding: 25px;">
        <park-info :infoData="infoData" />
      </big-title>
      <big-title :imgSrc="require('@/assets/images/bigScreen/icon-cz.png')" title="承租情况"
        style="height: 100%;width: 622px;padding: 25px;margin-left: 20px;margin-right: 20px;">
        <lessee-info :infoData="infoData" />
      </big-title>
      <gltf :id="getId" :parkCode="getParkCode" />
      <!-- <div class="center-row">
        <i class="el-icon-warning-outline"/>
        点击左右切换按钮即可实现园区/写字楼切换
      </div> -->
      <big-title :imgSrc="require('@/assets/images/bigScreen/icon-yq.png')" title="园区介绍"
        style="height: 100%;width: 622px;padding: 25px;margin: 0 20px;">
        <div class="introduce">
          {{ infoData.parkDiscription }}
          <!-- 虹桥国际科技广场，项目位于长宁区金钟路999号近淞虹路，电话：6218 6996；虹桥科技广场总建筑面积约9.5万平方米，其中公共绿地面积约11330平方米。按照5A级研发中心为标准进行设计建造，依照“园林式、高科技、总部型”的定位理念打造的5A级商务办公楼。虹桥科技广场由四栋造型现代的高科技建筑共同构成，是虹桥临空经济园区内罕见的，以国际5A级标准打造的高规格商务中心。集研发、办公、展示、会议于一体的完善配套商务设施，不仅适合跨国公司及国内外著名企业设置区域总部，同时也是作为研发中心、销售展示中心，现代物流中心、营运管理中心以及结算中心的理想商务平台。除了项目内部园林式的绿化景观配套，及园区内多家银行、会计师事务所为投资者提供各类金融服务，目前还有虹桥交通枢纽站的规划定位为园区带来更多样化的商务、休闲配套。物业公司：上海鑫达物业管理有限公司 -->
        </div>
      </big-title>
      <big-title :imgSrc="require('@/assets/images/bigScreen/icon-cz.png')" title="已入驻企业"
        style="height: 100%;width: 622px;padding: 25px;" viceTitle="" @viceTitleClick="viceTitleClick">
        <settled-enterprise :listData="infoData.coDateCoListMap" />
      </big-title>
      <all-enterprise ref="AllEnterprise" :coList="coList" />
      <!-- <right-row :infoData="infoData" /> -->
    </div>
  </div>
</template>

<script>
import Top from './top.vue'
import Gltf from './GLTF.vue'
// import LeftRow from './leftRow.vue'
// import RightRow from './rightRow.vue'
import { getDetail } from '@/api/bigScreen'
import { baseParkInfo } from '@/api/basicInfo'
import BigTitle from './bigTitle.vue'
import ParkInfo from './parkInfo.vue'
import LesseeInfo from './lesseeInfo.vue'
import SettledEnterprise from './SettledEnterprise.vue'
import AllEnterprise from './allEnterprise.vue'
export default {
  data() {
    return {
      infoData: {},
      showIndex: 0,
      list: [],
      coList: []
    }
  },
  computed: {
    getName() {
      return (this.list?.[this.showIndex] || {}).name
    },
    getId() {
      return (this.list?.[this.showIndex] || {}).id
    },
    getParkCode() {
      return (this.list?.[this.showIndex] || {}).parkCode
    }
  },
  watch: {
    'infoData.coList': {
      handler: function (val) {
        this.coList = [].concat(val)
      },
      deep: true
    }
  },
  components: {
    Top,
    // LeftRow,
    Gltf,
    // RightRow,

    BigTitle,
    ParkInfo,
    LesseeInfo,
    SettledEnterprise,
    AllEnterprise
  },
  methods: {
    viceTitleClick () {
      this.$refs.AllEnterprise.showDetails()
    },
    // 查询所有园区
    getAll() {
      baseParkInfo('query', {}).then(res => {
        console.log(res, 'queryquery')
        const { code, result } = res
        if (code !== 0) return
        this.list = result.records.map((item) => {
          return {
            name: item.parkName,
            id: item.id,
            parkCode: item.parkCode
          }
        })
        if (this.list.length > 0) {
          this.getInfo()
        }
      })
    },
    getInfo() {
      console.log(this.list, 'this.listthis.list');
      this.showIndex = this.list.findIndex(v => v.parkCode === this.$route.query.packCode)
        console.log(this.showIndex, 'this.showIndexthis.showIndex');
      let id = (this.list?.[this.showIndex] || {})?.id
      if (id === undefined) return
      getDetail({ id }).then(res => {
        console.log(res)
        const { code, result } = res
        if (code !== 0) return
        this.infoData = { ...result }
      })
    },
    showChange(type) {
      let index = this.showIndex
      switch (type) {
        case 'reduce':
          index -= 1
          if (index < 0) index = this.list.length - 1
          break;
        case 'plus':
          index += 1
          if (index >= this.list.length) index = 0
          break;
        default:
          index = type
      }
      this.showIndex = index
      this.getInfo()
    }
  },
  mounted() {
    this.getAll()
  }
}
</script>

<style lang="scss" scoped>
.big-screen-page {
  background: url("~@/assets/images/bigScreenPage/bg-mb.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  box-sizing: border-box;
  height: 860px;
  width: 4096px;

  .info-body {
    height: 560px;
    padding: 0 0.3rem;
    box-sizing: border-box;
    margin-top: 40px;
    // position: relative;
    // background-size: 100% 100%;
    // background-position: center;
    // background-repeat: no-repeat;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    border-radius: 0.1rem;

    .center-row {
      position: absolute;
      color: #A1BFDB;
      font-size: 0.18rem;
      top: 0.2rem;
      left: 50%;
      transform: translateX(-50%);
      background: rgba($color: #0B253E, $alpha: 0.5);
      padding: 0.04rem 0.2rem;
      border-radius: 0.04rem;
    }
  }
  .introduce {
    color: #fff;
    font-size: 0.12rem;
    line-height: 0.28rem;
  }
}
</style>